import type { Logger } from '@/services/logger'
import { isAndroidPlayStoreDistributionResolved } from '@/helpers/androidDistribution'
import { getPlatform, getPlatformInstance } from '@/platform'

/** Request "Install unknown apps" permission (opens Settings if needed). Runs after delay so plugin bridge is ready. */
async function requestInstallPermissionIfNeeded(): Promise<void> {
  if (await isAndroidPlayStoreDistributionResolved()) {
    return
  }
  const { invoke } = await import('@tauri-apps/api/core')
  try {
    await invoke('plugin:lucimark-android|requestInstallUnknownAppsPermissionIfNeeded')
  }
  catch {
    // Plugin may not be ready yet; App.vue fallback will retry when mounted
  }
}

export async function initPlayer(logger: Logger) {
  if (getPlatform() === 'android') {
    await getPlatformInstance().keepAwake()
    // Delay so the Tauri plugin bridge is ready; otherwise invoke can fail silently on first launch.
    setTimeout(() => {
      void requestInstallPermissionIfNeeded()
      void import('@/composables/usePlayer').then((m) => {
        m.syncAndroidScreenRotationToNativePreferences()
      }).catch(() => {})
    }, 2000)
  }
  logger.debug('android initialization complete')
}
